export default __webpack_public_path__ + "static/media/icon_chevron_right.488c38e0.svg";